import { useEffect, useState } from "react";
import { toast } from "sonner";
import { rpc } from "../../lib/rpc";
import { AdminPageHeader } from "../../components/admin/DataTable";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

// Issue #125: Schwellen liegen serverseitig (GET/PUT /api/settings) und
// wirken in Datenqualität, Ausleihen (überfällig) und Dashboard-KPI.
const FIELDS = [
    { key: "loan_overdue_days", label: "Ausleihe überfällig ab (Tage)", hint: "Dashboard-KPI, Ausleihen-Liste, Datenqualität" },
    { key: "restock_stale_days", label: "Nachbestellung überfällig ab (Tage)", hint: "Datenqualität: Karte Pending Restock" },
    { key: "staging_stale_days", label: "Staging-Bestand alt ab (Tage)", hint: "Datenqualität: Karte Staging" },
];

export default function AdminEinstellungen() {
    const [state, setState] = useState(null);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        rpc.get("/settings").then((r) => {
            if (r.ok) setState(r.data);
            else toast.error(r.error || "Einstellungen konnten nicht geladen werden.");
        });
    }, []);

    const valid = state && FIELDS.every((f) => Number.isInteger(state[f.key]) && state[f.key] >= 1 && state[f.key] <= 365);

    const save = async () => {
        setBusy(true);
        const res = await rpc.put("/settings", state);
        setBusy(false);
        if (!res.ok) return toast.error(res.error || "Speichern fehlgeschlagen.");
        setState(res.data);
        toast.success("Einstellungen gespeichert.");
    };

    return (
        <>
            <AdminPageHeader
                title="Einstellungen"
                subtitle="Schwellenwerte für Überfällig-Signale. Gelten für alle Nutzer, 1 bis 365 Tage."
            />
            <div className="max-w-xl space-y-4 rounded-xl border border-border bg-card/40 p-6" data-testid="admin-settings">
                {FIELDS.map((f) => (
                    <div key={f.key}>
                        <Label>{f.label}</Label>
                        <Input
                            type="number"
                            min={1}
                            max={365}
                            step={1}
                            value={state?.[f.key] ?? ""}
                            onChange={(e) =>
                                setState((s) => ({ ...s, [f.key]: e.target.value === "" ? "" : Number(e.target.value) }))
                            }
                            className="mt-1 h-10"
                            data-testid={`admin-setting-${f.key}`}
                        />
                        <p className="mt-1 text-xs text-muted-foreground">{f.hint}</p>
                    </div>
                ))}
                <Button onClick={save} disabled={!valid || busy} data-testid="admin-settings-save">
                    {busy ? "..." : "Speichern"}
                </Button>
            </div>
        </>
    );
}
